import React, {useEffect} from "react";
import banner from "../../assets/Banner.webp";

const Updates = () => {
    useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
      <section className="container-fluid55 relative mt-0 lg:px-0">
        <img
          src={banner}
          alt="Background"
          className="h-full w-full img-fluid2"
          style={{
            objectFit: "cover",
            minHeight: "320px",
            maxHeight: "80vh",
            filter: "brightness(100%)",
          }}
        />

        <div className="absolute top-1/2 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 px-3 text-center text-white">
          <h1 className="mt-4 text-3xl font-sf font-bold md:text-4xl lg:text-[28px]">
            Stay in the Loop with Live Updates
          </h1>

          <p className="ccustom-paragraph max-w-[700px] w-full mx-auto mt-4 px-4 text-lg font-normal font-sf md:text-lg lg:text-[22px]">
            With real-time tracking, you can monitor every delivery’s progress
            in just a glance. Customers receive instant updates, ensuring they
            stay informed and excited for their order’s arrival.
          </p>
        </div>
      </section>
  )
}

export default Updates